import React from 'react';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';

import { YouTubeVideo } from '../../components/YouTubeVideo';
import { Icon } from '../../stories/Icon';

interface VideoModalProps {
  show: boolean;
  setShow: (_: boolean) => void;
  setEnded: (_: boolean) => void;
  youtubeVideoId: string;
}

export const VideoModal: React.FC<VideoModalProps> = ({
  show,
  setShow,
  setEnded,
  youtubeVideoId,
}) => {
  const onEnd = () => {
    setShow(false);
    setEnded(true);
  };
  return (
    <StyledModal show={show} onHide={() => setShow(false)} keyboard={false}>
      <IconContainer>
        <StyledIcon name="times" onClick={() => setShow(false)} />
      </IconContainer>
      <Modal.Body>
        <div className="embed-container">
          <YouTubeVideo autoplayEnabled videoId={youtubeVideoId} onEnd={onEnd} />
        </div>
      </Modal.Body>
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  margin-top: 30vh;

  .modal-content {
    background: transparent;
    border: none;
  }

  .modal-body {
    padding: 0;
  }
`;

const IconContainer = styled.div`
  text-align: right;
  padding-bottom: 16px;
`;

const StyledIcon = styled(Icon)`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.white};
  font-size: 26pt;
`;
